import React from 'react';
import { Body, Theme } from '@routific/hive';

interface Props {
  text: string;
}

const TooltipBody: React.FC<Props> = ({ text }) => {
  const style = {
    color: Theme.Colors.gray0,
  };
  return (
    <Body style={style}>{text}</Body>
  );
};

export default TooltipBody;
